import script from "./joinUs.vue?vue&type=script&setup=true&lang=js"
export * from "./joinUs.vue?vue&type=script&setup=true&lang=js"

import "./joinUs.vue?vue&type=style&index=0&id=cc62df26&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc62df26"]])

export default __exports__